
import { useState, useCallback,useMemo, useEffect } from 'react'
import axios from 'axios'

const getLocalStorageToken = () => localStorage.getItem('access_token')
const setLocalStorageToken = (token) => localStorage.setItem('access_token', token)

const _axios = axios.create(); // export this and use it in all your components

const useAxiosLoader = () => {
  const [counter, setCounter] = useState(0);
  const inc = useCallback(() => setCounter(counter => counter + 1), [setCounter]); // add to counter
  const dec = useCallback(() => setCounter(counter => counter - 1), [setCounter]); // remove from counter
  
  const interceptors = useMemo(() => ({
    request: config => (inc(), config),
    response: response => (dec(), response),
    error: error => (dec(), Promise.reject(error)),
  }), [inc, dec]); // create the interceptors

  _axios.interceptors.request.use(
    (config) => {
      const token = getLocalStorageToken()
      if (token) {
        // config.headers["Authorization"] = 'Bearer ' + token;  // for Spring Boot back-end
        config.headers["accessToken"] = token; // for Node.js Express back-end
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  _axios.interceptors.response.use(
    (res) => {
      if(res.config.url.toLowerCase().includes("/getorders")){
        const token = res?.headers?.["accesstoken"];
        if(token) setLocalStorageToken(token)
      }
      return res;
    },
    (err) => {
      if(err.message == "Request failed with status code 401"){
        if (localStorage.getItem("isAndroidLogin")){
          localStorage.clear();
          android.logout();
        } else {
          localStorage.clear()
          window.location.href = "/"
        }
      }
      return Promise.reject(err);
    }
  );
  
  useEffect(() => {
    // add request interceptors
    const reqInterceptor = _axios.interceptors.request.use(interceptors.request, interceptors.error);
    // add response interceptors
    const resInterceptor =  _axios.interceptors.response.use(interceptors.response, interceptors.error);
    return () => {
      // remove all intercepts when done
      _axios.interceptors.request.eject(reqInterceptor);
      _axios.interceptors.response.eject(resInterceptor);
    };
  }, [interceptors]);
  return [counter > 0];
};
  
export {
  _axios,
  useAxiosLoader
}